import { Configuration, BaseUserApi, SearchTrackAdminApi } from '@/api';
import { axios } from 'hpsfir-managebase-ui';

interface BaseApi {
  baseUrl: string;
  uploadFileUrl: string;
  baseUserApi: BaseUserApi;
  searchTrackAdminApi: SearchTrackAdminApi;
}

const api: BaseApi = {} as BaseApi;

export const initApi = (basePath: string) => {
  const apiConfig = new Configuration({
    basePath,
  });
  api.baseUrl = basePath;
  api.uploadFileUrl = '/upload/file';
  api.baseUserApi = new BaseUserApi(apiConfig, basePath, axios);
  api.searchTrackAdminApi = new SearchTrackAdminApi(apiConfig, basePath, axios);
};

export const useApi = () => api;
